var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckBox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.405029,
    width: 20,
    height: 20,
    rx: 4,
    fill: "#366EE3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.77267 15.2006C7.66661 15.2006 7.56449 15.1815 7.46631 15.1433C7.36752 15.1057 7.28024 15.0491 7.20449 14.9733L3.40903 11.1779C3.27267 11.0415 3.20812 10.8785 3.2154 10.6888C3.22327 10.4997 3.28782 10.337 3.40903 10.2006C3.5454 10.0642 3.70843 9.99605 3.89812 9.99605C4.08721 9.99605 4.24237 10.0642 4.36358 10.2006L7.77267 13.6097L15.6363 5.74605C15.7575 5.60969 15.9166 5.5415 16.1136 5.5415C16.3105 5.5415 16.4696 5.60969 16.5909 5.74605C16.7272 5.88241 16.7954 6.04514 16.7954 6.23423C16.7954 6.42393 16.7272 6.58696 16.5909 6.72332L8.34085 14.9733C8.26509 15.0491 8.17812 15.1057 8.07994 15.1433C7.98115 15.1815 7.87873 15.2006 7.77267 15.2006Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBox);
export default __webpack_public_path__ + "static/media/Check-box.352b3190a819ae635e0747970d17f75b.svg";
export { ForwardRef as ReactComponent };